var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverviewNumberClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 3C9.735 3 3 9.735 3 18C3 26.265 9.735 33 18 33C26.265 33 33 26.265 33 18C33 9.735 26.265 3 18 3ZM24.525 23.355C24.315 23.715 23.94 23.91 23.55 23.91C23.355 23.91 23.16 23.865 22.98 23.745L18.33 20.97C17.175 20.28 16.32 18.765 16.32 17.43V11.28C16.32 10.665 16.83 10.155 17.445 10.155C18.06 10.155 18.57 10.665 18.57 11.28V17.43C18.57 17.97 19.02 18.765 19.485 19.035L24.135 21.81C24.675 22.125 24.855 22.815 24.525 23.355Z",
    fill: "#3176BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewNumberClock);
export default __webpack_public_path__ + "static/media/Overview-Number-clock.1bffbd6f226a44d5036101b46ea38f38.svg";
export { ForwardRef as ReactComponent };